// extracted by mini-css-extract-plugin
export default {"spacingInput":"WhereLive_spacingInput__DiXuP","spacingLink":"WhereLive_spacingLink__8oKBi"};